import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { listConveyor, unloadConveyorList } from '../../modules/conveyor/conveyorsSlice';

import ConveyorList from './ConveyorList';
import { useNavigate } from 'react-router-dom';
import { setOriginalConveyor } from '../../modules/conveyor/conveyorWriteSlice';

import { useCustomAlert } from '../../context/CustomAlertContext';

// import * as ConveyorAPI from '../../modules/conveyor/conveyorAPI';

const ConveyorListContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { projectId } = useParams();
    const [searchParams] = useSearchParams();

    // const [conveyors, setConveyors] = useState(null);

    const conveyors = useSelector((state) => state.conveyors.conveyors);
    const error = useSelector((state) => state.conveyors.error);
    const loading = useSelector((state) => state.loading);
    const user = useSelector((state) => state.user.user);
    const project = useSelector((state) => state.project.project);

    const language = useSelector((state) => state.language.language);
    const isEN = language === 'EN' ? true : false;
    const isJP = language === 'JP' ? true : false;

    const { showAlert } = useCustomAlert();

    if (!project || !projectId) {
        navigate(`/projects`);
    }

    useEffect(() => {
        const tag = searchParams.get('tag');
        // page가 없으면 1을 기본값으로 사용
        const page = parseInt(searchParams.get('page'), 10) || 1;
        const username = user?.username;

        dispatch(listConveyor({ projectId, username, tag, page }));

        // 언마운트될 때 리덕스에서 컨베이어 리스트 없애기
        return () => {
            dispatch(unloadConveyorList());
        };
    }, [dispatch, searchParams, projectId, user?.username]);

    const ownProject = (user && user._id) === (project && project.user._id);

    const onEditStructure = (conveyor) => {
        if (!ownProject) return; // ownProject일 때만 작동하도록 한다.

        // Drive가 선정되었는지 점검 후 Structure Estimation 호출. '25.6.5일 수정함.
        const drives = conveyor.body.drives;
        const isDriveSelected = Array.isArray(drives) && drives.length > 0;
        if (!isDriveSelected) {
            const message = isEN ? 'Select drive(s) first' : isJP ? 'ドライブを最初に選択してください。' : '드라이브를 먼저 선정하세요'
            // alert(message);
            // return;

            showAlert(message);
            return;
        }

        const isConfirmed = window.confirm(
            isEN
                ? 'Do you want to edit (modify) the structure weight?'
                : isJP
                ? '構造物の重量を編集（修正）しますか？'
                : 'Structure를 편집(수정) 하시겠습니까?',
        );

        if (!isConfirmed) {
            return;
        }

        dispatch(setOriginalConveyor(conveyor));
        // 컨베이어 리스트 없애기
        dispatch(unloadConveyorList());

        navigate(`/write/structure`);
    };

    return (
        <ConveyorList
            isProject={!!projectId}
            loading={!loading}
            error={error}
            conveyors={conveyors}
            project={project}
            onEditStructure={onEditStructure}
            ownProject={ownProject}
            showWriteButton={user}
        />
    );
};

export default React.memo(ConveyorListContainer);
